import CommentsSpamRoute from './CommentsSpamRoute';

export default CommentsSpamRoute;
